var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEditAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons-edit-alt"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.1093 4.3173C11.3298 4.0968 11.4511 3.80397 11.4511 3.49247C11.4511 3.18097 11.3298 2.88813 11.1093 2.66763L10.1841 1.74247C9.96359 1.52197 9.67076 1.40063 9.35926 1.40063C9.04776 1.40063 8.75492 1.52197 8.53501 1.74188L2.33301 7.92464V10.5001H4.90726L11.1093 4.3173ZM9.35926 2.5673L10.285 3.49188L9.35751 4.41588L8.43234 3.4913L9.35926 2.5673ZM3.49967 9.33339V8.4088L7.60634 4.31497L8.53151 5.24013L4.42542 9.33339H3.49967ZM2.33301 11.6667H11.6663V12.8334H2.33301V11.6667Z",
    fill: "#FAFBFA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEditAlt);
export default __webpack_public_path__ + "static/media/icons-edit-alt.fb9d2871e04cba9f5a4f0b1862c8cf43.svg";
export { ForwardRef as ReactComponent };